import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/es/radio/interface';
import { FC, PropsWithChildren, useCallback } from 'react';
import translations from './AlgorithmGraphActions.translations.json';
import { AlgorithmType } from './schema/zAlgorithmType';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-graph-actions',
);
addTranslations(translations);

export interface AlgorithmGraphActionsProps extends PropsWithChildren {
  algorithmType: AlgorithmType;
  value: 'joins' | 'mappings' | 'graph';
  onChange: (value: 'joins' | 'mappings' | 'graph') => void;
}

export const AlgorithmGraphActions: FC<AlgorithmGraphActionsProps> = (
  props,
) => {
  const { algorithmType, value, onChange } = props;
  const { t } = useTranslation();

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <Radio.Group
      value={value}
      onChange={handleChange}
      buttonStyle="solid"
      style={{ userSelect: 'none' }}
    >
      <Radio.Button value="mappings">{t('button.mappings')}</Radio.Button>
      {algorithmType === AlgorithmType.INSERT && (
        <Radio.Button value="joins">{t('button.joins')}</Radio.Button>
      )}
      <Radio.Button value="graph">{t('button.graphical')}</Radio.Button>
    </Radio.Group>
  );
};
